const state = {
  items: [],
};

const getters = {
  get: state => state.items,
};

const mutations = {
  SET(state, data) {
    state.items = _.isArray(data) ? data : [];
  },
};

const actions = {
  set({ commit }, data) {
    commit('SET', data)
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
